const StepRenderer = ({ step, value, onChange }) => {
  switch (step.type) {

    case "options":
      return (
        <div className="quiz-options">
          {step.options.map((opt, i) => (
            <div
              key={i}
              className={`quiz-option ${value === opt ? "selected" : ""}`}
              onClick={() => onChange(opt)}
            >
              {opt}
            </div>
          ))}
        </div>
      );

    case "input":
      return (
        <input
          className="quiz-input"
          type="text"
          placeholder={step.placeholder}
          value={value || ""}
          onChange={(e) => onChange(e.target.value)}
        />
      );

    case "textarea":
      return (
        <textarea
          className="quiz-textarea"
          placeholder={step.placeholder}
          value={value || ""}
          onChange={(e) => onChange(e.target.value)}
        />
      );

    case "multiInput":
      return (
        <div className="quiz-multi-inputs">
          {step.fields.map((field, i) => (
            <input
              key={i}
              className="quiz-input"
              type={field.type || "text"}
              placeholder={field.placeholder}
              value={value?.[field.id] || ""}
              onChange={(e) => onChange({
                ...value,
                [field.id]: e.target.value
              })}
            />
          ))}
        </div>
      );

    default:
      return null;
  }
};

export default StepRenderer;
